// extracted by mini-css-extract-plugin
export default {"overflow-list":"overflow-list--zM5Q3","overflow-list-spacer":"overflow-list-spacer--SaEhj"};